import { Grid, TextField, Typography } from '@mui/material'
import Button from '@mui/material/Button';
import React,{useEffect} from 'react'
import Resumedata from '../../Utilitize/Resumedata';
import Aos from 'aos'
import 'aos/dist/aos.css'
import './Contact.css'

function Contact() {
    useEffect(()=>{
        Aos.init();
    },[])
   
    return (
        <>
        <title>Contact me</title>
          <Grid container className="section" style={{paddingBottom:"30px",marginTop:"30px"}} spacing={5}>
             <Grid item xs={12} lg={7} data-aos="fade-right"
                                  data-aos-anchor="#example-anchor"
                                  data-aos-offset="500"
                                  data-aos-duration="2000">
                <Grid container>
                  <Grid item  className="section_title mb-4">
                     <span></span>
                     <h6 className="section_title_text">Contact form</h6>  
                  </Grid>
                  

                  <Grid item xs={12}>
                  <form action="https://formsubmit.co/freelancerrtushar@gmail.com" method="POST">
                    <Grid container spacing={2}>
                        
                            <Grid item xs={12} sm={6}>
                                <TextField required fullWidth name="name" label="Name"/>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField required fullWidth name="email" label="Email"/>
                                <input type="hidden" name="_captcha" value="false"></input>
                                <input type="hidden" name="_next" value="https://tusharprotfolio.netlify.app/success"></input>
                                <input type="hidden" name="_autoresponse" value="Your email send successfully.Thanks.We will contact you very soon."></input>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField required fullWidth name="message" label="Message" multiline rows={4}/>
                            </Grid>

                            <Grid item xs={12}>
                               <Button type="submit" variant="contained" size="large" style={{backgroundColor:"rgb(69, 180, 245)",color:"black",borderRadius:"30px"}}>Submit</Button>
                            </Grid>
                         
                    </Grid>
                    </form>
                  </Grid>
               </Grid>
            </Grid>
            <Grid item xs={12} lg={5} data-aos="fade-left"
                                  data-aos-anchor="#example-anchor"
                                  data-aos-offset="500"
                                  data-aos-duration="2000">
              <Grid container>
                  <Grid item  className="section_title mb-4">
                     <span></span>
                     <h6 className="section_title_text">Contact information</h6>  
                  </Grid>

                  <Grid item xs={12} >
                      <Grid container>
                          <Grid item xs={12}>
                              <Typography className="contactinfo_item">
                                  <span>Address : </span> {Resumedata.address}
                              </Typography>
                          </Grid>

                          <Grid item xs={12}>
                              <Typography className="contactinfo_item">
                                  <span>Phone : </span> {Resumedata.phone}
                              </Typography>
                          </Grid>

                          <Grid item xs={12}>
                              <Typography className="contactinfo_item">
                                  <span>Phone : </span> {Resumedata.email}
                              </Typography>
                          </Grid>
                      </Grid>
                  </Grid>

                  <Grid item xs={12}>
                      <Grid container className="contact_socialcontainer">
                          {Object.keys(Resumedata.socials).map((key)=>{
                              return(
                                  <Grid item className="contact_social">
                                     <a href={Resumedata.socials[key].link} target="_blank">{Resumedata.socials[key].icon}</a>
                                  </Grid>
                                 

                               )
                           })}  
                      </Grid>
                  </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
              <Grid item xs={12}>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14612.66699208635!2d90.45475237842558!3d23.70573865099736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b77186e2e3f9%3A0x1e98ee292b8b578b!2z4Kau4Ka-4Kak4KeB4Kav4Ka84Ka-4KaH4Kay!5e0!3m2!1sbn!2sbd!4v1638131079463!5m2!1sbn!2sbd" style={{width:"100%",height:"400px",padding:"30px"}}></iframe>
              </Grid>
          </Grid>
        </>
    )
}

export default Contact
